import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Card,
    List,
    Popconfirm, Form, Switch, notification, Select
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";
import cookie from "react-cookies";

const {Title, Text} = Typography;
const {Content} = Layout;

const Delete = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            fetch("https://pd.pokemonbye.com:8084/api/setsellstockstate?state=0&id=" + id.id)
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload()

                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        console.log('删除后将不可恢复');
        setOpen(false);
    };
    return (
        <Popconfirm
            title="删除后将不可恢复"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Button onClick={showPopconfirm}>
                删除
            </Button>
        </Popconfirm>
    );
};
const onChange = (date, dateString) => {
    console.log(dateString);
};
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '产品信息修改成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};

class PageBuildAssayEd extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const userid = cookie.load('userId');
        this.state = {
            title: "化验数据上报",
            county: [],
            id: id,
            userid:userid,
            list: [],
            options: []
        };
    }

    componentDidMount() {
        var id = this.state.id
        if(id){
        }else{

            fetch("https://pd.pokemonbye.com:8084/api/getsellstock")
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        let options = [];
                        for (let i = 0; i < array.length; i++) {
                            let l = {
                                value: array[i].id,
                                label: array[i].stockname
                            }
                            options.push(l)
                            array[i].id = i + 1
                        }
                        this.setState({
                            isLoaded: true,
                            options: options
                        });
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
    }
    formRef = React.createRef();
    render() {
        const onFinish = (values) => {
            var list = {};
            list.assay_num = values.assay_num ? values.assay_num : this.state.list.assay_num;
            list.assay_type = values.assay_type ? values.assay_type : this.state.list.assay_type;
            list.assay_date = values.assay_date ? moment(values.assay_date).format('yyyy-MM-DD') : this.state.list.assay_date;
            list.assay_gcm3 = values.assay_gcm3 ? values.assay_gcm3 : 0;
            list.assay_m2kg = values.assay_m2kg ? values.assay_m2kg : 0;
            list.assay_7d = values.assay_7d ? values.assay_7d : 0;
            list.assay_28d = values.assay_28d ? values.assay_28d : 0;
            list.assay_F = values.assay_F ? values.assay_F : 0;
            list.assay_mgo = values.assay_mgo ? values.assay_mgo : 0;
            list.assay_h2o = values.assay_h2o ? values.assay_h2o : 0;
            list.assay_so3 = values.assay_so3 ? values.assay_so3 : 0;
            list.assay_cl = values.assay_cl ? values.assay_cl : 0;
            list.assay_loi = values.assay_loi ? values.assay_loi : 0;
            list.assay_na2o = values.assay_na2o ? values.assay_na2o : 0;
            list.assay_unit = this.state.userid ? this.state.userid : 1;
            console.log(list)
            if(this.state.id){
            }else{
                function queryParse(query){
                    let queryText = "";
                    for(let key in query){
                        queryText += `${key}=${query[key]}&`;
                    }
                    return queryText.slice(0,-1);
                }

                fetch("https://pd.pokemonbye.com:8084/api/insertsellbuildassay",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            openNotification();

                            setTimeout(window.location.href="/pagebuildassay",1000);
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Form
                                    labelCol={{
                                        span: 4,
                                    }}
                                    wrapperCol={{
                                        span: 6,
                                    }}
                                    layout="horizontal"
                                    size="Large"
                                    onFinish={onFinish}
                                    ref={this.formRef}
                                    autoComplete="off"
                                >
                                    <Form.Item label="产品类型" name="assay_type" rules={[{required: true},]}>
                                        <Select
                                            defaultValue={this.state.options.stocktype_id}
                                            style={{
                                                width: 120,
                                            }}
                                            options={this.state.options}
                                        />
                                    </Form.Item>
                                    <Form.Item label="日期选择" name="assay_date" rules={[{required: true},]}>
                                        <DatePicker onChange={onChange} format='YYYY-MM-DD'/>
                                    </Form.Item>
                                    <Form.Item label="编号" name="assay_num" rules={[{required: true},]}>
                                        <Input placeholder={this.state.list.assay_num} />
                                    </Form.Item>
                                    <Form.Item label="细度" name="assay_F" rules={[{required: true},]}>
                                        <InputNumber addonAfter="质量分数/%≥" placeholder={this.state.list.assay_F} />
                                    </Form.Item>
                                    <Form.Item label="需水量比" name="assay_h2o" rules={[{required: true},]}>
                                        <InputNumber addonAfter="质量分数/%≤" placeholder={this.state.list.assay_h2o} />
                                    </Form.Item>
                                    <Form.Item label="三氧化硫" name="assay_so3" rules={[{required: true},]}>
                                        <InputNumber addonAfter="质量分数/%≤" placeholder={this.state.list.assay_so3} />
                                    </Form.Item>
                                    <Form.Item label="游离氧化钙" name="assay_cl" rules={[{required: true},]}>
                                        <InputNumber addonAfter="质量分数/%≤" placeholder={this.state.list.assay_cl} />
                                    </Form.Item>
                                    <Form.Item label="烧失量" name="assay_loi" rules={[{required: true},]}>
                                        <InputNumber addonAfter="质量分数/%≤" placeholder={this.state.list.assay_loi} />
                                    </Form.Item>
                                    <Form.Item label="强度活性指数" name="assay_na2o" rules={[{required: true},]}>
                                        <InputNumber addonAfter="质量分数/%≤" placeholder={this.state.list.assay_na2o} />
                                    </Form.Item>
                                    <Form.Item
                                        wrapperCol={{
                                            offset: 4,
                                            span: 16,
                                        }}
                                    >
                                        <Button type="primary" htmlType="submit">{this.state.id?'提交修改':'提交'}</Button>
                                    </Form.Item>
                                </Form>

                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageBuildAssayEd;


